<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Void Pembayaran</h5>
            </template>
            <div class="search-wrapper align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.filterNoFaktur" name="filterNoFaktur"
                            id="filterInput"
                            type="search"
                            placeholder="Masukkan no. faktur"
                        ></b-form-input>
                        <multiselect class="mr-2" v-model="input.filterCabang" name="cabang"
                            :options="cabangOption" :internal-search="true" :allow-empty="true"
                            deselect-label="" select-label="" label="name" track-by="id"
                            placeholder="-- Pilih Dari Cabang --" />
                        <b-form-select class="mr-2" v-model="input.filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih status --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="dataVoidPembayaran" 
                :fields="fields"
                :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data void pembayaran.
                </template>
                <template v-slot:cell(noKwitansi)="row">
                    <div>{{ row.item.noKwitansi }}</div>
                    <div class="smallText text-muted">{{ row.item.noFaktur }}</div>
                </template>
                <template v-slot:cell(namaAnggota)="row">
                    <p class="mb-0">{{row.item.namaAnggota}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.nomorAnggota}}</p>
                </template>
                <template v-slot:cell(diajukanOleh)="row">
                    <div v-if="row.item.diajukanOleh != null">{{ row.item.diajukanOleh }}</div>
                    <div v-else>---SISTEM---</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormat(row.item.diajukanPada)}} {{$helper.changeDateFormatGetHour(row.item.diajukanPada)}}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == 'PENDING'">PENDING</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'DITERIMA'">DITERIMA</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'DITOLAK'">DITOLAK</b-badge>
                    <b-badge v-else>{{ row.item.status }}</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="voidPbyViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Void pembayaran belum diproses.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Void pembayaran sudah diterima. Transaksi pembayaran dinyatakan VOID dan data gadai dikembalikan seperti sebelum pembayaran.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITOLAK</h6>
                <p class="smallText mb-0">Void pembayaran ditolak. Transaksi pembayaran tidak digugurkan.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'cek-gadai',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterNoFaktur: null,
                filterCabang: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "noKwitansi", label: "No. Kwitansi & Faktur" },
                { key: "cabang", label: "Cabang"},
                { key: "namaAnggota", label: "Anggota" },
                { key: "diajukanOleh", label: "Diajukan Oleh/Pada"},
                { key: "status", label: "Status"},
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [ 
                { id: '0', name: 'PENDING' },
                { id: '1', name: 'APPROVED' },
                { id: '2', name: 'SUSPECT' }
            ],
            cabangOption: [],
            dataVoidPembayaran: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.cabangOption = this.$helper.getAllCabang()

            let getVoidPembayaran= this.$axios.get("approval-void-pembayaran/"+this.query).then(response => {
                this.dataVoidPembayaran = response.data.data
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getVoidPembayaran]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Ambil Data Cek Gadai -----------------

        getVoidPembayaran(){
            this.toggleBusy()
            this.dataVoidPembayaran = []

            if (this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang.id
            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            
            this.$axios.get("approval-void-pembayaran/"+this.query).then(response => {
                this.dataVoidPembayaran = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getVoidPembayaran()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getVoidPembayaran()
            }
        },

        onReset(){
            this.input.filterNoFaktur = null
            this.input.filterCabang = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getVoidPembayaran()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getVoidPembayaran()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        }
    },

    created(){
        this.init()
    }
}
</script>
